import React, { useEffect, useRef } from "react";
import { useField, useFormikContext } from "formik";
import { SearchMultipleSelectField } from "../../../../components/src/form";
import { ISelectOption } from "../../../../components/src/form/SearchMultipleSelectField";
import { withClientIdInPositionClientIds } from "./fundParseUtils";
import { FundParseFormValues } from "./fundParseDefaults";

interface FundParseClientFieldsProps {
    clientOptions: ISelectOption[];
    disabled: boolean;
}

export function FundParseClientFields({ clientOptions, disabled }: FundParseClientFieldsProps): React.ReactElement {
    const [clientIdField] = useField<string>("client_id");
    const [positionClientIdsField] = useField<string[]>("position_client_ids");
    const { setFieldValue } = useFormikContext<FundParseFormValues>();
    const previousClientIdRef = useRef("");
    const clientsAvailable = clientOptions.length > 0;

    useEffect(() => {
        const clientId = clientIdField.value;
        if (clientId === previousClientIdRef.current) {
            return;
        }
        previousClientIdRef.current = clientId;
        if (!clientId) {
            return;
        }

        const positionClientIds = Array.isArray(positionClientIdsField.value) ? positionClientIdsField.value : [];
        const nextPositionClientIds = withClientIdInPositionClientIds(clientId, positionClientIds);
        if (nextPositionClientIds.length !== positionClientIds.length) {
            setFieldValue("position_client_ids", nextPositionClientIds);
        }
    }, [clientIdField.value, positionClientIdsField.value, setFieldValue]);

    return (
        <div className="min-w-0 col-span-full">
            <SearchMultipleSelectField
                name="position_client_ids"
                label="Position client IDs"
                className=""
                disabled={disabled || !clientsAvailable}
                options={clientOptions}
            />
        </div>
    );
}
